// extracted by mini-css-extract-plugin
export default {"grid":"DashboardGrid_grid__Ywp68","primary":"DashboardGrid_primary__nyFHF","rail":"DashboardGrid_rail__dFGW2"};